import React, { Component } from 'react';
import ReactSwipe from 'react-swipe';
import cx from 'classnames';

export default class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = { activeSlide: 0 };
  }

  render() {
    const { children, navButtonTopAdjustment, className } = this.props;
    const childrenLength = children.length;

    if (!childrenLength) return null;
    if (childrenLength === 1) return <div className={className}>{children}</div>;

    const swipeOptions = {
      callback: index => this.setState({ activeSlide: index % childrenLength }),
    };

    const px = navButtonTopAdjustment || 0;
    const navButtonStyle = {
      top: `calc(50% - ${px}px)`,
    };

    return (
      <div className={cx(className, 'slider')}>
        <div className="slider-count">{this.state.activeSlide + 1}/{childrenLength}</div>

        <ReactSwipe ref="reactSwipe" swipeOptions={swipeOptions}>
          {children}
        </ReactSwipe>

        <button className="slider-prev" style={navButtonStyle} type="button" onClick={() => this.refs.reactSwipe.prev()}>
          <div className="icon icon-arrow-right"></div>
        </button>
        <button className="slider-next" style={navButtonStyle} type="button" onClick={() => this.refs.reactSwipe.next()}>
          <div className="icon icon-arrow-right"></div>
        </button>
      </div>
    );
  }
}

Slider.propTypes = {
  navButtonTopAdjustment: React.PropTypes.number,
  children: React.PropTypes.node,
  className: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/Slider.jsx